var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.online_fitting
      ? _c("div", [
          _c("img", {
            staticClass: "shape_img",
            staticStyle: { "max-width": "100px", "max-height": "100px" },
            attrs: { src: _vm.shape_img },
          }),
          _vm._v(" "),
          _c("p", [
            _c("span", { staticClass: "band_size" }, [
              _vm._v("Band: "),
              _c("b", [_vm._v(_vm._s(_vm.$root.underbust_size) + '"')]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "cup_size" }, [
              _vm._v("Cup: "),
              _c("b", [_vm._v(_vm._s(_vm.$root.cup_size) + '"')]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "shape" }, [
              _vm._v("Shape: "),
              _c("b", [
                _vm._v(_vm._s(_vm.$root.shapeToDisplayName(_vm.$root.shape))),
              ]),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "shape" }, [
              _vm._v("Waist:\n        "),
              _c(
                "b",
                [
                  !_vm.$root.skipped_bottoms
                    ? [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$root.waist_size) +
                            '"\n          '
                        ),
                      ]
                    : [_vm._v("\n            Skipped\n          ")],
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "shape" }, [
              _vm._v("Hip:\n        "),
              _c(
                "b",
                [
                  !_vm.$root.skipped_bottoms
                    ? [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$root.hip_size) +
                            '"\n          '
                        ),
                      ]
                    : [_vm._v("\n            Skipped\n          ")],
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("h2", [
            _vm._v("\n      Bra size: "),
            _c("b", [
              _vm._v(
                "(US) " +
                  _vm._s(_vm.$root.us_from_uk(_vm.online_fitting.fitted_size)) +
                  " /\n                (UK) " +
                  _vm._s(_vm.online_fitting.fitted_size)
              ),
            ]),
            _vm._v(" "),
            _c("div", {
              staticStyle: { display: "inline-block", width: "10px" },
            }),
            _vm._v("\n      Bottom Size: "),
            _c("b", [
              _vm._v(_vm._s(_vm.online_fitting.generic_bottom_simple_size)),
            ]),
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v("What are you looking for?")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "container" },
            _vm._l(_vm.$root.types, function (value, key) {
              return _c(
                "button",
                {
                  key: key,
                  staticClass: "btn",
                  class: { selected: _vm.$root.type === value },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.$root.type = value
                    },
                  },
                },
                [_vm._v("\n        " + _vm._s(key) + "\n      ")]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("h3", [
            _vm._v(
              "What " +
                _vm._s(_vm.$root.isBottomType ? "fit" : "band fit") +
                " do you prefer?"
            ),
          ]),
          _vm._v(" "),
          _vm.online_fitting
            ? _c("div", { staticClass: "fit" }, [
                _c(
                  "div",
                  { staticClass: "range-value" },
                  [
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-wide btn-slide",
                          class: { selected: _vm.$root.fit === "loose" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.$root.fit = "loose"
                            },
                          },
                        },
                        [
                          _vm.$root.isBottomType
                            ? [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$root.get_alternate_size(
                                        _vm.online_fitting
                                          .generic_bottom_simple_size,
                                        1
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$root.us_from_uk(
                                        _vm.online_fitting.loose_fit
                                      )
                                    ) +
                                    " US / " +
                                    _vm._s(_vm.online_fitting.loose_fit) +
                                    " UK\n            "
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("LOOSE")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-wide btn-slide",
                          class: { selected: _vm.$root.fit === "normal" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.$root.fit = "normal"
                            },
                          },
                        },
                        [
                          _vm.$root.isBottomType
                            ? [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.online_fitting
                                        .generic_bottom_simple_size
                                    ) +
                                    "\n            "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$root.us_from_uk(
                                        _vm.online_fitting.fitted_size
                                      )
                                    ) +
                                    " US / " +
                                    _vm._s(_vm.online_fitting.fitted_size) +
                                    " UK\n            "
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("SNUG")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-wide btn-slide",
                          class: { selected: _vm.$root.fit === "tight" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.$root.fit = "tight"
                            },
                          },
                        },
                        [
                          _vm.$root.isBottomType
                            ? [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$root.get_alternate_size(
                                        _vm.online_fitting
                                          .generic_bottom_simple_size,
                                        -1
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$root.us_from_uk(
                                        _vm.online_fitting.snug_fit
                                      )
                                    ) +
                                    " US / " +
                                    _vm._s(_vm.online_fitting.snug_fit) +
                                    " UK\n            "
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("TIGHT")]),
                    ]),
                    _vm._v(" "),
                    [
                      _c("div", {
                        staticClass: "left-indicator",
                        style: _vm.leftComputedStyle,
                      }),
                      _vm._v(" "),
                      _vm.$root.isBottomType &&
                      _vm.online_fitting.bottoms_percentage
                        ? _c("div", {
                            staticClass: "indicator",
                            style: _vm.computedStyle,
                          })
                        : !_vm.$root.isBottomType &&
                          _vm.online_fitting.bra_percentage
                        ? _c("div", {
                            staticClass: "indicator",
                            style: _vm.computedStyle,
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "right-indicator",
                        style: _vm.rightComputedStyle,
                      }),
                    ],
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ])
      : _c("div", [_vm._v("\n    Loading...\n  ")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }